<template>
  <div v-loading="loading">
    <el-card shadow="never">
      <el-button type="primary" @click="getWBExcel">{{
        language("common.download")
      }}</el-button>
    </el-card>
    <cc-table
      :loadData="false"
      :dataArr="itmesArr"
      :config="table"
      :params="params"
      :refeshParams="refeshTable"
      :showIndex="false"
    ></cc-table>
  </div>
</template>
<script>
export default {
  props: {
    ids: Array,
  },
  data() {
    return {
      shopData: {},
      loading: false,
      itmesArr: [],
      refeshTable: -1,
      params: {},
      table: {
        api: "",
        showPager: false,

        columns: [
          {
            prop: "productId",
            lable: "ProductId",
            minWidth: 230,
          },
          {
            prop: "thumb",
            lable: "Thumb",
            type: "img",
            urlPropName: "thumb",
            w: 30,
            minWidth: 80 + 0,
            h: 30,
          },
          {
            prop: "productName",
            lable: "ProductName",
            minWidth: 200,
          },
          {
            prop: "productNum",
            lable: "ProductNum",
            minWidth: 255,
          },
          {
            prop: "confirmCount",
            lable: "ConfirmCount",
          },
          {
            prop: "reqCount",
            lable: "ReqCount",
          },
        ],
        buttons: [],
      },
    };
  },
  methods: {
    getWBExcel() {
      window.open(
        process.env.VUE_APP_exportMasterWB +
          `api/deliver/wayBill/getWBExcel?appId=supnr&ids=${this.ids.join(
            ","
          )}&shopNum=${this.shopData.shopNum}&mchShopNum=${
            this.shopData.shopNum
          }`
      );
      this.$message(this.language("common.downloading"));
    },
  },
  mounted() {
    this.shopData = this.$shopData;

    this.ccRequest
      .do(
        "admin/merchant/waybill/pickingListByItem",
        { ids: this.ids.join(",") },
        "POST"
      )
      .then((res) => {
        this.itmesArr = res;
        this.loading = false;
      })
      .catch((err) => {
        console.log(err);
        this.loading = false;
        this.$message.error(err.response.data.message);
      });
  },
};
</script>
